export default __webpack_public_path__ + "static/requestADemo-b773750e261b33fd01d21acec1de1927.png";